import { useState } from "react";
import { useSelector } from "react-redux";
import Header from "../../components/header";
import axios from "axios";
import "./feedback.css";

export default function Feedback() {
  const { user } = useSelector((state) => ({ ...state }));
  const [subject, setSubject] = useState("");
  const [suggestions, setSuggestions] = useState("");
  const [rating, setRating] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!subject) {
      setError("Please provide a subject for your feedback");
      return;
    }
    
    if (rating === 0) {
      setError("Please select a rating");
      return;
    }

    try {
      setLoading(true);
      setError("");
      setSuccess("");

      await axios.post(
        `${process.env.REACT_APP_API_URL || ""}/api/feedback/submitFeedback`,
        {
          subject,
          suggestions,
          rating,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      setSuccess("Thank you for your feedback! We appreciate your input.");
      setSubject("");
      setSuggestions("");
      setRating(0);
      setLoading(false);
      
      setTimeout(() => {
        setSuccess("");
      }, 5000);
    } catch (error) {
      setLoading(false);
      setError(error.response?.data?.message || "Something went wrong. Please try again.");
    }
  };

  const handleStarClick = (value) => {
    setRating(value);
  };

  return (
    <div className="feedback">
      <Header page="feedback" />
      <div className="feedback_container">
        <div className="feedback_wrapper">
          <div className="feedback_header">
            <h1>Share Your Feedback</h1>
            <p>
              Your comments and suggestions help us make UsmaAPP better and create a greater experience for everyone.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="feedback_form">
            <div className="feedback_section">
              <label htmlFor="subject">Subject</label>
              <select
                id="subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="subject_select"
              >
                <option value="">Select a subject...</option>
                <option value="Bug Report">Bug Report</option>
                <option value="Feature Request">Feature Request</option>
                <option value="Performance Issue">Performance Issue</option>
                <option value="User Interface">User Interface</option>
                <option value="General Feedback">General Feedback</option>
                <option value="Privacy & Security">Privacy & Security</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="feedback_section">
              <label htmlFor="suggestions">Suggestions</label>
              <textarea
                id="suggestions"
                value={suggestions}
                onChange={(e) => setSuggestions(e.target.value)}
                placeholder="How can we improve UsmaApp?"
                rows="2"
                maxLength="1000"
              />
              <span className="char_count">{suggestions.length}/1000</span>
            </div>

            <div className="feedback_section">
              <label>Rate Your Experience</label>
              <div className="rating_container">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span
                    key={star}
                    className={`star ${rating >= star ? "filled" : ""}`}
                    onClick={() => handleStarClick(star)}
                  >
                    ★
                  </span>
                ))}
                <span className="rating_text">
                  {rating === 0 && "Select a rating"}
                  {rating === 1 && "Poor"}
                  {rating === 2 && "Fair"}
                  {rating === 3 && "Good"}
                  {rating === 4 && "Very Good"}
                  {rating === 5 && "Excellent"}
                </span>
              </div>
            </div>

            {error && (
              <div className="feedback_error">
                <i className="error_icon"></i>
                {error}
              </div>
            )}

            {success && (
              <div className="feedback_success">
                <i className="success_icon"></i>
                {success}
              </div>
            )}

            <button
              type="submit"
              className="feedback_submit"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit Feedback"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
